import {
  START_LOADING,
  END_LOADING,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTION,
  ADD_TRANSACTION,
  UPDATE_TRANSACTION,
  DELETE_TRANSACTION,
  FETCH_TRIAL_BALANCE,
  FETCH_BALANCE_SHEET,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  transactions: [],
  transaction: null,
};

const transactions = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_TRANSACTION:
      const updatedTransactions = state.transactions.some(
        (transaction) => transaction._id === action.payload._id
      )
        ? state.transactions.map((transaction) =>
            transaction._id === action.payload._id
              ? action.payload
              : transaction
          )
        : [...state.transactions, action.payload];
      return {
        ...state,
        transactions: updatedTransactions,
        transaction: action.payload,
      };
    case ADD_TRANSACTION:
      return {
        ...state,
        transactions: [...state.transactions, action.payload],
        transaction: action.payload, // Assuming you want to view the newly added transaction
      };
    case UPDATE_TRANSACTION:
      return {
        ...state,
        transactions: state.transactions.map((transaction) =>
          transaction._id === action.payload._id ? action.payload : transaction
        ),
        transaction:
          state.transaction && state.transaction._id === action.payload._id
            ? action.payload
            : state.transaction,
      };
    case DELETE_TRANSACTION:
      return {
        ...state,
        transactions: state.transactions.filter(
          (transaction) => transaction._id !== action.payload
        ),
        transaction:
          state.transaction && state.transaction._id === action.payload
            ? null
            : state.transaction,
      };
    case FETCH_TRIAL_BALANCE:
      return {
        ...state,
        trialBalance: action.payload,
      };
    case FETCH_BALANCE_SHEET:
      return {
        ...state,
        balanceSheet: action.payload,
      };
    default:
      return state;
  }
};

export default transactions;
